import { render, staticRenderFns } from "./ViewDocumentPdf.vue?vue&type=template&id=6ebd53b9&scoped=true&"
import script from "./ViewDocumentPdf.vue?vue&type=script&lang=js&"
export * from "./ViewDocumentPdf.vue?vue&type=script&lang=js&"
import style0 from "./ViewDocumentPdf.vue?vue&type=style&index=0&id=6ebd53b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebd53b9",
  null
  
)

export default component.exports